import React from 'react'
import { useState } from "react";
import StudentRegister from "./StudentRegister/StudentRegister";
import TutorRegister from "./TutorRegister/TutorRegister";
const RegisterContent = () => {
    const [selectedRole, setSelectedRole] = useState(null);
    return (

        <div>
            <div className="login-background ">
                {/* <section class="forget-screen-main-secion main-section"> */}
                <div className=" login-main-container ">
                    <div className="row login-form-part">
                        <div className="card login-form">
                            {/* <nav className="nav-butn">
                                <div
                                    style={{ flexWrap: "nowrap", display: "flex" }}
                                    className="nav nav-tabs login-nav login-nav-tabs"
                                    id="nav-tab"
                                    role="tablist"
                                >
                                    <button
                                        className="nav-link login-nav-link active px-1"
                                        id="nav-home-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#nav-home"
                                        type="button"
                                        role="tab"
                                        aria-controls="nav-home"
                                        aria-selected="true"
                                    >
                                        Student Register
                                    </button>
                                    <button
                                        className="nav-link login-nav-link"
                                        id="nav-profile-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#nav-profile"
                                        type="button"
                                        role="tab"
                                        aria-controls="nav-profile"
                                        aria-selected="false"
                                    >
                                        Tutor Register
                                    </button>
                                   
                                </div>
                            </nav> */}
                            {/* <div className="tab-content" id="nav-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-home"
                                    role="tabpanel"
                                    aria-labelledby="nav-home-tab"
                                >
                                    <StudentRegister />
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="nav-profile"
                                    role="tabpanel"
                                    aria-labelledby="nav-profile-tab"
                                >
                                    <TutorRegister />
                                </div>
                            </div> */}

                            {!selectedRole && (
                                <div className="role-selector mb-4">

                                    <h4 className="text-center mb-1">Choose your role</h4>
                                    <p className="text-center text-muted mb-4">
                                        Register as a...
                                    </p>

                                    <div className="role-cards">

                                        <div
                                            className="role-card"
                                            onClick={() => setSelectedRole("student")}
                                        >
                                            <img src="assets/img/student.png" alt="Student" />
                                            <p>Student</p>
                                        </div>

                                        <div
                                            className="role-card"
                                            onClick={() => setSelectedRole("tutor")}
                                        >
                                            <img src="assets/img/teacher.jpg" alt="Tutor" />
                                            <p>Tutor</p>
                                        </div>

                                    </div>

                                </div>
                            )}

                            {/* STUDENT REGISTER */}
                            {selectedRole === "student" && (
                                <div className="form-body">

                                    <a
                                        className="back-btn"
                                        onClick={() => setSelectedRole(null)}
                                        style={{ marginLeft: "20px" }}
                                    >
                                        ← Back
                                    </a>

                                    <StudentRegister />

                                </div>
                            )}

                            {/* TUTOR REGISTER */}
                            {selectedRole === "tutor" && (
                                <div className="form-body">

                                    <a
                                        className="back-btn"
                                        onClick={() => setSelectedRole(null)}
                                        style={{ marginLeft: "20px" }}
                                    >
                                        ← Back
                                    </a>

                                    <TutorRegister />

                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>


        </div>

    )
}

export default RegisterContent